import { useQuery } from 'react-query'

import { apiFetch } from 'lib/action-helpers'
import { organizationsPaths as paths, USERS_LIST } from '../index'
import { useOrganization } from 'hooks/context/organization-context'

const getOrganizationUsers = async (organization) => {
  const data = await apiFetch(paths.users(organization))
  return data
}

export const useOrganizationUsersQuery = () => {
  const { organization } = useOrganization()

  return useQuery(
    [...USERS_LIST, organization?.id],
    () => getOrganizationUsers(organization?.id),
    {
      staleTime: Infinity,
      enabled: !!organization?.id
    }
  )
}
